import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "filter-header" }
const _hoisted_2 = {
  class: "filters",
  id: "filter-tab-external-content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "stcSelectedProduct" }, "Product: ", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  value: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "product-stc-listing" }
const _hoisted_8 = {
  key: 0,
  class: "stc-table"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Aircraft Make/Model"),
  /*#__PURE__*/_createElementVNode("th", null, "Dealer Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Authority"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "Est. Availability")
], -1 /* HOISTED */)
const _hoisted_10 = {
  colspan: "5",
  class: "aircraft-make"
}
const _hoisted_11 = { class: "aircraft-model" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "d-md-none" }, "Authority:", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "d-md-none" }, "Status:", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "d-md-none" }, "Estimated Availability:", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass([[{ 'd-none': $options.filteredProducts.length === 1 }], "form-control form-select"]),
            id: "stcSelectedProduct",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProduct) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.updateStcs()))
          }, [
            ($options.filteredProducts.length !== 1)
              ? (_openBlock(), _createElementBlock("option", _hoisted_4, "Select product"))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProducts, (product) => {
              return (_openBlock(), _createElementBlock("option", {
                value: product.name
              }, _toDisplayString(product.name), 9 /* TEXT, PROPS */, _hoisted_5))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 34 /* CLASS, HYDRATE_EVENTS */), [
            [_vModelSelect, _ctx.selectedProduct]
          ]),
          ($options.filteredProducts.length === 1)
            ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(_ctx.selectedProduct), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      ($options.productStcs.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.orderedAircraftMakes, (aircraftMake) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(aircraftMake), 1 /* TEXT */)
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.productStcs.filter(s => s.aircraft_make == aircraftMake), (stc) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", _hoisted_11, _toDisplayString(stc.aircraft_model), 1 /* TEXT */),
                      _createElementVNode("td", {
                        innerHTML: $options.dealerNameAndLink(stc)
                      }, null, 8 /* PROPS */, _hoisted_12),
                      _createElementVNode("td", null, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(stc.authority), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(stc.status), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(stc.estimated_availability), 1 /* TEXT */)
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}